import React from 'react'
import { Link } from '@fs/zion-router'
import { useTranslation } from 'react-i18next'

// Helper for rendering subnavItems objects
export default function NavItem({ as: As = Link, label, ...props }) {
  const [t] = useTranslation()

  return <As {...props}>{t(label)}</As>
}
